import { useState, useEffect } from "react";
import Icon from "../common/Icon";
import { useNavigate } from "react-router-dom";

function ProductCarousel({
  products,
  className = "",
  className2 = "",
  icon = "",
}) {
  const [visibleIndex, setVisibleIndex] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!products || products.length === 0) return;

    const interval = setInterval(() => {
      setVisibleIndex((prevIndex) =>
        prevIndex + 1 < products.length ? prevIndex + 1 : 0
      );
      setLoaded(false);
    }, 5000);

    return () => clearInterval(interval);
  }, [products]);

  if (!products || products.length === 0) return null;

  const product = products[visibleIndex];

  return (
    <div
      className=" pointer-events-auto relative w-full h-full  hover:text-secondary"
      style={{ transform: "rotate(-10deg)" }}
      // onClick={() => navigate(`/shop/${product.slug}`)}
    >
      <div className={`flex items-center justify-center ${className}`}>
        <img
          key={visibleIndex}
          src={process.env.REACT_APP_BACKEND_URL + "public/" + product.image}
          onLoad={() => setLoaded(true)}
          onError={(e) => {
            e.currentTarget.src = require("../../assets/images/link.png");
            setLoaded(true);
          }}
          alt="image"
          className={`${className2} max-h-full max-w-full object-contain z-[9]
              [@keyframes_slideIn2]{from{transform:translateX(40px);opacity:0}to{transform:translateX(0);opacity:1}}
              animate-[slideIn2_0.7s_ease-out]
              `}
        />
      </div>

      <Icon
        icon="basket"
        // size={37}
        style={{ transform: "rotate(10deg)" }}
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/shop/${product.slug}`);
        }}
        title="Click to view product details"
        className={` w-[25px]  lg:w-[30px]  1xl:w-[35px] 2.5xl:w-[41px] hover:text-secondary absolute text-green cursor-pointer z-[10] ${icon}`}
      />
    </div>
  );
}

export default ProductCarousel;
